import { useEffect, useState } from "react";
import { isFresh } from "@/lib/usePolling";

/**
 * Pulsing red "NEW" badge that auto-hides 60s after `createdAt`.
 *
 * Re-renders every 5 seconds while visible so it disappears on its own
 * without a parent re-render.
 */
export default function NewBadge({ createdAt, label = "NEW" }) {
  const [, force] = useState(0);
  useEffect(() => {
    if (!isFresh(createdAt)) return;
    const id = setInterval(() => force((n) => n + 1), 5000);
    return () => clearInterval(id);
  }, [createdAt]);
  if (!isFresh(createdAt)) return null;
  return (
    <span
      className="ml-2 inline-flex items-center gap-1 text-[9px] font-bold uppercase tracking-widest px-1.5 py-0.5 bg-[#8B1C22] text-white animate-pulse"
      data-testid="new-badge"
    >
      <span className="w-1.5 h-1.5 rounded-full bg-white" />
      {label}
    </span>
  );
}
